import {publishClientSideMetrics} from "../handler/ParentDataHandler";
import React from "react"
import {FormattedMessage} from "react-intl";
import {DATE_TIME_FORMAT, EXTRA_LARGE, EXTRA_SMALL, L, LARGE, M, MEDIUM, S, SMALL, XL, XS, NC, HEAVY_BULKY_NON_CON} from "./Constants";
import {EMPTY_STRING_PLACEHOLDER} from "../inductmanagementv2/Constants";

export function getTime(time) {
    if (time == null || time === '') {
        return ''
    }
    let date = new Date(time);
    let hour = date.getHours();
    let minutes = date.getMinutes();
    return ((hour < 10 ? '0' + hour : hour) + ":" + (minutes < 10 ? '0' + minutes : minutes))
}

export function getRegion() {
    let location = window.location.href
    let region = "US"
    if (location.includes("ui.ivsna")) {
        region = "US"
    } else if (location.includes("ui.ivseu")) {
        region = "EU"
    } else if (location.includes("ui.ivsjp")) {
        region = "FE"
    }
    return region;
}

export function getLocaleDateTime(dateTime) {
    if (dateTime) {
        const date = new Date(dateTime);
        let hour = date.getHours();
        let minutes = date.getMinutes();
        return date.toLocaleDateString() + " " + ((hour < 10 ? '0' + hour : hour) + ":" + (minutes < 10 ? '0' + minutes : minutes));
    }
    return ""
}

export function getSplitViewHeaders(metrics) {
    return metrics[Object.keys(metrics).reduce((a, b) =>
        Object.keys(metrics[a]).length > Object.keys(metrics[b]).length ? a : b)];
}

export const getAliasFromLoginId = (loginId) => {
    if (loginId.indexOf('@') !== -1) {
        return loginId.substr(0, loginId.indexOf('@'));
    }
    return loginId;
}

/**
 * This method return the refresh interval in milliseconds
 * @returns {number}
 */
export function getRefreshInterval() {
    return 60 * 1000;
}

export function logOperationalMetric(startTime, processName, metricName, isSuccess) {
    isSuccess ?
        publishToCSM({
            startTime: startTime,
            processName: processName,
            metricName: metricName
        }) : publishErrorToCSM({
            processName: processName,
            metricName: metricName
        })
}

export function publishToCSM(args) {
    let metricValue = getTimeDiff(args.startTime);
    const countMetricReq = publishClientSideMetricsRequest(args.processName, args.metricName, 1, metricTypeEnum.COUNT);
    const timeMetricReq = publishClientSideMetricsRequest(args.processName, args.metricName, metricValue, metricTypeEnum.TIME);
    publishClientSideMetrics(countMetricReq);
    publishClientSideMetrics(timeMetricReq);
}

export function publishErrorToCSM(args) {
    const countMetricReq = publishClientSideMetricsRequest(args.processName, args.metricName + "Error" , 1, metricTypeEnum.COUNT);
    publishClientSideMetrics(countMetricReq);
}

export function publishCountToCSM(args) {
    const countMetricReq = publishClientSideMetricsRequest(args.processName, args.metricName , 1, metricTypeEnum.COUNT);
    publishClientSideMetrics(countMetricReq);
}

function getTimeDiff(time) {
    return Date.now() - time ;
}

const metricTypeEnum = {
    COUNT: "count",
    TIME: "time"
};

function publishClientSideMetricsRequest(processName, metricName, metricValue, metricType) {
    return {
        processName: processName,
        metricName: metricName,
        metricValue: metricValue,
        metricType: metricType
    }
}

export function parseCapabilitiesResponse(response) {
    return response ? JSON.parse(response.capability) : '';
}

export const chainWalk = (func, defaultValue) => {
    try {
        const value = func()
        return (value === null || value === undefined) ? defaultValue : value;
    } catch (e) {
        return defaultValue
    }
}

function getFormattedId(value, formattedIdPrefix) {
    const formattedIdSuffix = value.toLocaleLowerCase().split(' ').join('_')
    return formattedIdPrefix.concat(formattedIdSuffix);
}

export const getDisplayName = (value, formattedIdPrefix) => {
    return <FormattedMessage id={getFormattedId(value, formattedIdPrefix)} defaultMessage={value}/>
}

/**
 * Returns the current time in format [ MonthName dd, YYYY, HH:MM:SS GMT+__:__ ]
 * This pattern may slightly change according to current locale.
 * @param locale
 * @return string
 */
export const getCurrentFormattedTime = (locale) => {
    const currentDate = new Date();
    return new Intl.DateTimeFormat(locale, DATE_TIME_FORMAT).format(currentDate)
}

/**
 * Converts time in milliseconds to the format [ MonthName dd, YYYY, HH:MM:SS GMT+__:__ ]
 * This pattern may slightly change according to current locale.
 * @param timeInMillis
 * @return string
 */
export const getFormattedTime = (timeInMillis) => {
    if (timeInMillis === null || timeInMillis === undefined) {
        return EMPTY_STRING_PLACEHOLDER
    }
    const date = new Date(timeInMillis);
    return new Intl.DateTimeFormat([], DATE_TIME_FORMAT).format(date)
}

export const findTotalNoOfColumns = (groupedVolumeColumnsSet) => {
    const totalNumberOfColumns = Array.from(groupedVolumeColumnsSet).length;
    return totalNumberOfColumns;
}
export const findMiddleColumnNumber = (groupedVolumeColumnsSet) => {
        const totalNumberOfColumns = findTotalNoOfColumns(groupedVolumeColumnsSet);
        const midColumnNumber = totalNumberOfColumns%2 ? Math.round((totalNumberOfColumns-1)/2) : Math.floor((totalNumberOfColumns-1)/2);
        return midColumnNumber;
}

export const findAlignmentForColumn = (groupedVolumeColumnsSet) => {
    const totalNumberOfColumns = findTotalNoOfColumns(groupedVolumeColumnsSet);
    const alignmentForColumn = totalNumberOfColumns%2 ? "center" : "right";
    return alignmentForColumn;
}

/**
 * Add sub column volume headings for Package Size
 * @param columnValue
 * @return string
 */
export const findTotalUniqueValuesForPackageSizeColumn = (subVolumeColumnsHeadingSet) => {
    subVolumeColumnsHeadingSet.add(XS);
    subVolumeColumnsHeadingSet.add(S);
    subVolumeColumnsHeadingSet.add(M);
    subVolumeColumnsHeadingSet.add(L);
    subVolumeColumnsHeadingSet.add(XL);
    subVolumeColumnsHeadingSet.add(NC);
    return subVolumeColumnsHeadingSet;
}

/**
 * Converts the column value of Package Size to values to be sent in Request
 * @param columnValue
 * @return string
 */
export const packageSizeColumnValueToRequestValue = (columnValue) => {
    const columnValueToRequestValueMap = new Map();
    columnValueToRequestValueMap.set(XS, EXTRA_SMALL);
    columnValueToRequestValueMap.set(S, SMALL);
    columnValueToRequestValueMap.set(M, MEDIUM);
    columnValueToRequestValueMap.set(L, LARGE);
    columnValueToRequestValueMap.set(XL, EXTRA_LARGE);
    columnValueToRequestValueMap.set(NC, HEAVY_BULKY_NON_CON);
    return columnValueToRequestValueMap.get(columnValue);
}


// WEBPACK FOOTER //
// ./src/components/util/Util.js